module.exports = __webpack_public_path__ + "img/icomoon.595d59b.svg";